import React, { FC, ReactNode, useState } from 'react';
import styles from './optionsDropdown.module.scss';
import { Col, Dropdown, Menu, MenuProps, Row } from 'antd';
import { ReactComponent as DotsIcon } from 'assets/icons/Three dot V.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import clsx from 'clsx';
import OrganizationModal from '../OrganizationModal';
import COButton from '../COButton';

const { Item } = Menu;

export enum OptionsMenu {
  DELETE = 'delete',
  DELETE_MENU_TITLE = 'Delete',
  EDIT_MENU_TITLE = 'Edit',
  GO_BACK = 'Go back',
}

export interface DeleteModalProps {
  deleteContent?: ReactNode;
  deleteTitle: string;
  onDelete: () => Promise<void>;
  loading?: boolean;
}

interface OptionsMenuProps {
  deleteHandler?: () => void;
  editHandler?: () => void;
  className?: string;
  deleteModalprops?: DeleteModalProps;
  isDelete?: boolean;
  isEdit?: boolean;
}

//This is an options dropdown to show edit and delete buttons from a 3 dot menu
const OptionsDropdown: FC<OptionsMenuProps> = ({
  deleteHandler,
  editHandler,
  className,
  deleteModalprops,
  isDelete = true,
  isEdit,
}) => {
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const handleToggleModal = () => setDeleteVisible(prev => !prev);
  const handleDelete = () => {
    deleteHandler ? deleteHandler() : handleToggleModal();
  };
  const items: MenuProps['items'] = [
    ...(isEdit
      ? [
          {
            label: (
              <Item
                key={OptionsMenu.EDIT_MENU_TITLE}
                icon={<EditIcon className={styles.editIcon} />}
                onClick={editHandler}>
                <div className={styles.editText}>
                  {OptionsMenu.EDIT_MENU_TITLE}
                </div>
              </Item>
            ),
            key: OptionsMenu.EDIT_MENU_TITLE,
          },
        ]
      : []),
    ...(isDelete
      ? [
          {
            label: (
              <Item
                key={OptionsMenu.DELETE}
                icon={<DeleteIcon className={styles.deleteIcon} />}
                onClick={handleDelete}>
                <div className={styles.redText}>
                  {OptionsMenu.DELETE_MENU_TITLE}
                </div>
              </Item>
            ),
            key: OptionsMenu.DELETE,
          },
        ]
      : []),
  ];

  const onDelete = async () => {
    await deleteModalprops?.onDelete();
    handleToggleModal();
  };
  return (
    <>
      <div className={clsx(styles.menuContainer, className ?? '')}>
        <Dropdown menu={{ items }}>
          <div className={styles.triggerContainer}>
            <DotsIcon className={styles.dotsIcon} />
          </div>
        </Dropdown>
      </div>
      <OrganizationModal
        visible={deleteVisible}
        onClose={handleToggleModal}
        width={450}
        children={
          <Row className={styles.deleteModalContent}>
            <Col span={24} className={styles.deleteTitle}>
              {deleteModalprops?.deleteTitle}
            </Col>
            {deleteModalprops?.deleteContent && (
              <Col span={24}>{deleteModalprops?.deleteContent}</Col>
            )}
            <Col span={24}>
              <Row gutter={[15, 15]} className={styles.deleteButtonsContainer}>
                <Col span={12}>
                  <COButton
                    primary
                    children={OptionsMenu.DELETE_MENU_TITLE}
                    onClick={onDelete}
                    loading={deleteModalprops?.loading}
                  />
                </Col>
                <Col span={12}>
                  <COButton
                    secondary
                    children={OptionsMenu.GO_BACK}
                    onClick={handleToggleModal}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        }
      />
    </>
  );
};

export default OptionsDropdown;
